module.exports = __webpack_public_path__ + "img/activity_other3.20c10d56.jpg";